import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ImpersonationBanner from './components/ImpersonationBanner';

import Login        from './pages/Login';
import Today        from './pages/Today';
import Exercises    from './pages/Exercises';
import ExerciseDetail from './pages/ExerciseDetail';
import Routines     from './pages/Routines';
import History      from './pages/History';
import Profile      from './pages/Profile';
import Admin        from './pages/Admin';
import AdminStats   from './pages/AdminStats';
import AdminTemplates from './pages/AdminTemplates';
import AdminOptions   from './pages/AdminOptions';

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  const { isAuthenticated, user } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!user?.is_admin) return <Navigate to="/today" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/today" replace />} />
      <Route path="/today" element={
        <PrivateRoute><Today /></PrivateRoute>
      } />
      <Route path="/exercises" element={
        <PrivateRoute><Exercises /></PrivateRoute>
      } />
      <Route path="/exercises/:id" element={
        <PrivateRoute><ExerciseDetail /></PrivateRoute>
      } />
      <Route path="/routines" element={
        <PrivateRoute><Routines /></PrivateRoute>
      } />
      <Route path="/history" element={
        <PrivateRoute><History /></PrivateRoute>
      } />
      <Route path="/profile" element={
        <PrivateRoute><Profile /></PrivateRoute>
      } />
      <Route path="/admin" element={
        <AdminRoute><Admin /></AdminRoute>
      } />
      <Route path="/admin/stats" element={
        <AdminRoute><AdminStats /></AdminRoute>
      } />
      <Route path="/admin/templates" element={
        <AdminRoute><AdminTemplates /></AdminRoute>
      } />
      <Route path="/admin/options" element={
        <AdminRoute><AdminOptions /></AdminRoute>
      } />
      <Route path="*" element={<Navigate to="/today" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ImpersonationBanner />
        <ScrollToTop />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
